<div class="container-v2 ui-page-shell-modern" lang="pt-BR">
  <h1>Configuração de data de corte de fatura</h1>

  <div class="info-bar">
    <div class="search-container">
      <i class="fa"
         style="--svg-icon-url: url('assets/icons/search-icon.svg'); --svg-icon-color: #ffffff; --svg-icon-width: 15px; --svg-icon-height: 17px;"></i>
      <input type="text"
             [(ngModel)]="searchTerm"
             (ngModelChange)="onSearchChange($event)"
             placeholder="Buscar por Mês/Ano..." />
    </div>

    <div class="vertical-divider"></div>

    <div class="info-summary">
      <div>Total: <strong>{{ totalItems }}</strong> Registros</div>
    </div>
  </div>

  <div class="table-wrapper">
    <div class="table-header">
      <span role="button" tabindex="0" (click)="sortBy('monthYear')"
        (keydown.enter)="sortBy('monthYear')" (keydown.space)="sortBy('monthYear')">
        Mês/Ano
        <i class="fa sort-icon"
           [style.--svg-icon-url]="getSortIcon('monthYear')"
           style="--svg-icon-width: 16px; --svg-icon-height: 16px; --svg-icon-color: #ffffff;"></i>
      </span>
      <span>
        Data Limite
      </span>
      <span>Hora Limite</span>
      <button class="btn-action" (click)="openCreateModal()">
        <i class="fa"
           style="--svg-icon-url: url('assets/icons/vector-comissao.svg'); --svg-icon-color: #ffffff; --svg-icon-width: 12px; --svg-icon-height: 12px;"></i>
        Data de Corte
      </button>
    </div>

    <div class="no-results" *ngIf="!configs || configs.length === 0">
      Nenhum registro encontrado.
    </div>

    <div class="row" *ngFor="let item of configs">
      <span>{{ item?.month !== null && item?.year !== null ? (item.month.toString().padStart(2, '0') + '/' + item.year) : '-' }}</span>
      <span>{{ item.limitDate | date: 'dd/MM/yyyy' }}</span>
      <span>{{ item.limitTime }}</span>
      <div class="actions" style="margin-left: 84px;">
        <button class="btn" (click)="openEditModal(item)">
          <i class="fa"
             style="--svg-icon-url: url('assets/icons/edit-icon.svg'); --svg-icon-color: #ffffff; --svg-icon-width: 15px; --svg-icon-height: 17px;"></i>
        </button>
        <button class="btn" (click)="confirmRemove(item)">
          <i class="fa"
             style="--svg-icon-url: url('assets/icons/trash-icon.svg'); --svg-icon-color: #ffffff; --svg-icon-width: 15px; --svg-icon-height: 17px;"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="pagination-bar">
    <label>
      Linhas por página:
      <select [(ngModel)]="rowsPerPage" (ngModelChange)="onRowsPerPageChange($event)">
        <option *ngFor="let option of rowsPerPageOptions" [value]="option">{{ option }}</option>
      </select>
    </label>

    <button (click)="goToPage(1)" [disabled]="currentPage === 1">«</button>
    <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">‹</button>

    <span class="current-page">{{ currentPage }}</span>
    <span>de {{ totalPages }}</span>

    <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">›</button>
    <button (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages">»</button>
  </div>

  <div class="modal-overlay" role="presentation" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
    <div class="modal-box compact" role="presentation" (click)="$event.stopPropagation()">
      <div class="modal-body">
        <p class="modal-message">Tem certeza de que deseja excluir este registro?</p>
      </div>
      <div class="modal-actions">
        <button class="btn ui-btn ui-btn--primary" (click)="executeDelete()">Sim</button>
        <button class="btn ui-btn ui-btn--secondary" (click)="closeDeleteModal()">Não</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" role="presentation" *ngIf="showEditModal" (click)="closeEditModal()">
    <div class="modal-box" role="presentation" (click)="$event.stopPropagation()">
      <h2>{{ selectedConfig ? 'Editar' : 'Nova' }} Data limite</h2>
      <hr />
      <div class="modal-error" *ngIf="modalErrorMessage">
        {{ modalErrorMessage }}
      </div>
      <div class="modal-body form-grid">
        <input type="hidden" [(ngModel)]="form.id" name="id" />
        <div class="form-group">
          <label class="required" for="nf-month-year">Mês/Ano:</label>
          <select id="nf-month-year" [(ngModel)]="form.monthYear">
            <option value="">Selecione...</option>
            <option *ngFor="let option of availableMonthYears" [value]="option">{{ option }}</option>
          </select>
          <div class="field-error" *ngIf="formErrors['monthYear']">{{ formErrors['monthYear'] }}</div>
        </div>
        <div class="form-group">
          <label class="required" for="nf-cutoff-date">Data Limite:</label>
          <input id="nf-cutoff-date" type="date" lang="pt-BR" [(ngModel)]="form.cutoffDate" [attr.min]="todayString" />
          <div class="field-error" *ngIf="formErrors['cutoffDate']">{{ formErrors['cutoffDate'] }}</div>
        </div>
        <div class="form-group">
          <label class="required" for="nf-cutoff-time">Hora Limite:</label>
          <input id="nf-cutoff-time" type="time" lang="pt-BR" [(ngModel)]="form.cutoffTime" />
          <div class="field-error" *ngIf="formErrors['cutoffTime']">{{ formErrors['cutoffTime'] }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn ui-btn ui-btn--secondary" (click)="closeEditModal()">Voltar</button>
        <button class="btn ui-btn ui-btn--primary" (click)="saveConfig()">Salvar</button>
      </div>
    </div>
  </div>
</div>
